import CopyToClipboard from 'react-copy-to-clipboard';
import { Copy } from '@ankr.com/ui';
import { IconButton, IconButtonOwnProps } from '@mui/material';

import { TextTooltip } from 'modules/common/components/TextTooltip';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { copyButtonTranslation } from './translation';
import { useCopyButton } from './hooks/useCopyButton';
import { useCopyButtonStyles } from './useCopyButtonStyles';

interface CopyButtonProps {
  className?: string;
  classes?: Partial<ReturnType<typeof useCopyButtonStyles>['classes']>;
  size?: IconButtonOwnProps['size'];
  text: string;
}

export const CopyButton = ({
  className: externalClassName,
  classes: classesOverrides,
  size,
  text,
}: CopyButtonProps) => {
  const { onCopy, tooltipProps } = useCopyButton();

  const { classes, cx } = useCopyButtonStyles(undefined, {
    props: { classes: classesOverrides },
  });

  const { keys, t } = useTranslation(copyButtonTranslation);

  const className = cx(classes.root, externalClassName);

  return (
    <TextTooltip {...tooltipProps} title={t(keys.copied)}>
      <IconButton size={size} className={className}>
        <CopyToClipboard text={text} onCopy={onCopy}>
          <Copy className={classes.copyIcon} />
        </CopyToClipboard>
      </IconButton>
    </TextTooltip>
  );
};
